import React from 'react';

import {View, Text, StyleSheet} from 'react-native';

import {colors} from '../../classes/Colors';
import TrustTag from '../TrustTag';

const ImageNavCardLayoutHeader = ({title, trust, secondTitle}) => {
  return (
    <View style={styles.header}>
      <Text style={styles.title}>{title}</Text>
      {trust && <TrustTag trust={trust} />}
      {secondTitle && (
        <Text style={[styles.title, {marginLeft: 8}]}>{secondTitle}</Text>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  header: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#82797929',
    alignContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    paddingBottom: 11,
    marginVertical: 16,
  },
  title: {
    color: colors.Green900,
    fontSize: 16,
    fontWeight: '600',
    textAlign: 'left',
    marginRight: 8,
    paddingBottom: 3,
  },
});

export default ImageNavCardLayoutHeader;
